/* Fuzance · JavaScript commun : en-tête, recherche, poinçons, fin de piste, utilitaires.
   Tout est écrit pour survivre au rechargement d'une section dans l'éditeur de thème
   (éléments personnalisés + écouteurs délégués). */
(function () {
  'use strict';
  if (window.FZ && window.FZ.__core) return;
  var FZ = window.FZ = window.FZ || {};
  FZ.__core = true;

  /* ---------- Utilitaires ---------- */
  FZ.qs = function (sel, root) { return (root || document).querySelector(sel); };
  FZ.qsa = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  FZ.debounce = function (fn, wait) {
    var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, wait); };
  };
  FZ.esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  };
  /* Nom court d'un produit : ce qui précède la première virgule du titre (désactivable dans les réglages du thème) */
  FZ.shortName = function (t) {
    var full = String(t == null ? '' : t).trim();
    if (FZ.shortNames === false || full.indexOf(',') < 1) return full;
    var s = full.split(',')[0].trim();
    return s || full;
  };
  FZ.reduceMotion = function () { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; };

  /* Formatage d'un prix en centimes selon le format monétaire de la boutique, avec espace insécable et € dans la police du texte */
  FZ.money = function (cents, opts) {
    /* En euros : mise en forme à la française (1 180 €, 590,50 €), comme le snippet fz-money */
    if (String(FZ.currency || '').toUpperCase() === 'EUR') {
      var c = Math.round(Number(cents) || 0), whole = Math.floor(c / 100), dec = c % 100;
      var txt = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0') + (dec ? ',' + (dec < 10 ? '0' : '') + dec : '') + '\u00a0€';
      return opts && opts.html ? FZ.esc(txt).replace('€', '<span class="fz-eur">€</span>') : txt;
    }
    var fmt = (FZ.moneyFormat || '{{amount}} €').replace(/<[^>]*>/g, '');
    var n = Math.round(Number(cents) || 0) / 100;
    function fixed(v, dec, thou, decSep) {
      var s = v.toFixed(dec).split('.');
      s[0] = s[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thou);
      return s.join(decSep);
    }
    var out = fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount': return fixed(n, 2, ',', '.');
        case 'amount_no_decimals': return fixed(n, 0, ',', '.');
        case 'amount_with_comma_separator': return fixed(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fixed(n, 0, '.', ',');
        case 'amount_with_space_separator': return fixed(n, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return fixed(n, 0, ' ', ',');
        default: return fixed(n, 2, ',', '.');
      }
    });
    out = out.replace(/([.,]00)(?=\D|$)/, '').replace(/ /g, ' ');
    if (opts && opts.html) out = FZ.esc(out).replace('€', '<span class="fz-eur">€</span>');
    return out;
  };

  /* Piège à focus pour les fenêtres (tiroir, modales) */
  FZ.trapFocus = function (container, e) {
    if (e.key !== 'Tab') return;
    var f = FZ.qsa('a[href],button:not([disabled]),input:not([disabled]):not([type=hidden]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])', container)
      .filter(function (el) { return el.offsetParent !== null || el === document.activeElement; });
    if (!f.length) { e.preventDefault(); return; }
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  };

  /* Événement « contenu ajouté » : à émettre après avoir injecté du HTML */
  FZ.refresh = function (root) { FZ.initTickets(root || document); document.dispatchEvent(new CustomEvent('fz:content', { detail: { root: root || document } })); };

  /* ---------- En-tête : menu Collection, tiroir mobile, recherche ---------- */
  var FzHeader = function () { return Reflect.construct(HTMLElement, [], FzHeader); };
  FzHeader.prototype = Object.create(HTMLElement.prototype);
  FzHeader.prototype.constructor = FzHeader;
  Object.setPrototypeOf(FzHeader, HTMLElement);

  FzHeader.prototype.connectedCallback = function () {
    var self = this;
    if (this._ready) return; this._ready = true;
    this.bar = this.querySelector('[data-fz-bar]');
    this.items = FZ.qsa('.fz-nav-item', this);
    this.burger = this.querySelector('[data-fz-burger]');
    this.search = this.querySelector('[data-fz-search]');
    this.searchBtn = this.querySelector('[data-fz-search-toggle]');
    this._off = [];
    function on(t, ev, fn, o) { t.addEventListener(ev, fn, o); self._off.push(function () { t.removeEventListener(ev, fn, o); }); }

    /* Menu déroulant (ordinateur) : survol ou clic, Échap pour fermer */
    this.items.forEach(function (item) {
      var btn = item.querySelector('.fz-nav-btn'), timer = null, pinned = false;
      function isMouse(e) { return e.pointerType === 'mouse' || e.pointerType === 'pen'; }
      function open() {
        clearTimeout(timer);
        self.items.forEach(function (o) { if (o !== item) o._close && o._close(); });
        self.closeSearch();
        item.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true');
      }
      function close() { clearTimeout(timer); pinned = false; item.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); }
      item._close = close; item._open = open;
      on(item, 'pointerenter', function (e) { if (isMouse(e)) open(); });
      on(item, 'pointerleave', function (e) { if (isMouse(e) && !pinned) timer = setTimeout(close, 220); });
      on(btn, 'click', function () {
        if (!item.classList.contains('is-open')) { open(); pinned = true; }
        else if (!pinned) { pinned = true; }
        else { close(); }
      });
      on(item, 'focusout', function (e) { if (e.relatedTarget && !item.contains(e.relatedTarget)) close(); });
      FZ.qsa('.fz-mega a', item).forEach(function (a) { on(a, 'click', close); });
    });

    /* Tiroir mobile */
    function setDrawer(open) {
      if (!self.burger) return;
      self.bar.classList.toggle('is-open', open);
      self.burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      self.burger.setAttribute('aria-label', open ? 'Fermer le menu' : 'Ouvrir le menu');
      var o = self.burger.querySelector('[data-fz-burger-open]'), c = self.burger.querySelector('[data-fz-burger-close]');
      if (o) o.hidden = open; if (c) c.hidden = !open;
      if (open) self.closeSearch();
    }
    this.setDrawer = setDrawer;
    if (this.burger) {
      on(this.burger, 'click', function () { setDrawer(!self.bar.classList.contains('is-open')); });
      var scrim = this.querySelector('[data-fz-scrim]');
      if (scrim) on(scrim, 'click', function () { setDrawer(false); });
      FZ.qsa('.fz-drawer a', this).forEach(function (a) { on(a, 'click', function () { setDrawer(false); }); });
      FZ.qsa('[data-fz-acc]', this).forEach(function (acc) {
        var body = document.getElementById(acc.getAttribute('aria-controls'));
        on(acc, 'click', function () {
          var o = acc.getAttribute('aria-expanded') === 'true';
          acc.setAttribute('aria-expanded', o ? 'false' : 'true'); if (body) body.hidden = o;
        });
      });
    }

    /* Recherche avec suggestions */
    this.closeSearch = function () {
      if (!self.search || self.search.hidden) return;
      self.search.hidden = true;
      if (self.searchBtn) self.searchBtn.setAttribute('aria-expanded', 'false');
    };
    if (this.search && this.searchBtn) {
      var input = this.querySelector('[data-fz-search-input]'), box = this.querySelector('[data-fz-search-results]');
      on(this.searchBtn, 'click', function () {
        var open = self.search.hidden;
        if (open) {
          self.items.forEach(function (i) { i._close && i._close(); }); setDrawer(false);
          self.search.hidden = false; self.searchBtn.setAttribute('aria-expanded', 'true');
          if (input) input.focus();
        } else { self.closeSearch(); self.searchBtn.focus(); }
      });
      var ctrl = null;
      var run = FZ.debounce(function () {
        var q = input.value.trim();
        if (q.length < 2) { box.innerHTML = ''; return; }
        if (ctrl) ctrl.abort();
        ctrl = window.AbortController ? new AbortController() : null;
        var url = ((FZ.routes && FZ.routes.suggest) || '/search/suggest') + '.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=4&resources[options][unavailable_products]=last';
        fetch(url, ctrl ? { signal: ctrl.signal } : {}).then(function (r) { return r.json(); }).then(function (j) {
          var list = (j && j.resources && j.resources.results && j.resources.results.products) || [];
          if (!list.length) { box.innerHTML = '<p class="fz-sres__none">Rien ne correspond à « ' + FZ.esc(q) + ' ». Essayez une couleur ou un modèle.</p>'; return; }
          box.innerHTML = '<ul class="fz-sres" role="list">' + list.map(function (p) {
            var img = (p.featured_image && p.featured_image.url) || p.image || '';
            if (img) img = img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=132';
            return '<li><a href="' + FZ.esc(p.url) + '"><span class="fz-sres__img">' + (img ? '<img src="' + FZ.esc(img) + '" alt="" width="44" height="58" loading="lazy">' : '') +
              '</span><span class="fz-sres__t">' + FZ.esc(FZ.shortName(p.title)) + '</span><span class="fz-sres__p">' + FZ.money(Math.round(parseFloat(p.price) * 100), { html: true }) + '</span></a></li>';
          }).join('') + '</ul>';
        }).catch(function (e) { if (e && e.name === 'AbortError') return; box.innerHTML = ''; });
      }, 220);
      if (input) on(input, 'input', run);
    }

    /* Échap et clic à l'extérieur */
    on(document, 'keydown', function (e) {
      if (e.key !== 'Escape') return;
      var opened = self.items.filter(function (i) { return i.classList.contains('is-open'); })[0];
      if (opened) { var inside = opened.contains(document.activeElement); opened._close(); if (inside) opened.querySelector('.fz-nav-btn').focus(); return; }
      if (self.bar.classList.contains('is-open')) { setDrawer(false); if (self.burger) self.burger.focus(); return; }
      if (self.search && !self.search.hidden) { self.closeSearch(); if (self.searchBtn) self.searchBtn.focus(); }
    });
    on(document, 'pointerdown', function (e) {
      self.items.forEach(function (i) { if (!i.contains(e.target)) i._close(); });
      if (!self.bar.contains(e.target)) setDrawer(false);
      if (self.search && !self.search.hidden && !self.search.contains(e.target) && !(self.searchBtn && self.searchBtn.contains(e.target))) self.closeSearch();
    });

    /* Éditeur de thème : ouvrir le menu quand on sélectionne son bloc */
    on(document, 'shopify:block:select', function (e) {
      var it = e.target.closest && e.target.closest('.fz-nav-item');
      if (it && it._open && window.matchMedia('(min-width:861px)').matches) it._open();
    });
    on(document, 'shopify:block:deselect', function (e) {
      var it = e.target.closest && e.target.closest('.fz-nav-item');
      if (it && it._close) it._close();
    });
  };
  FzHeader.prototype.disconnectedCallback = function () {
    (this._off || []).forEach(function (f) { f(); });
    this._ready = false;
  };
  if (!customElements.get('fz-header')) customElements.define('fz-header', FzHeader);

  /* ---------- Poinçons des tickets ---------- */
  var lastTicket = null;
  function punch(t, auto) {
    if (FZ.punch === false || FZ.reduceMotion()) return;
    var now = Date.now();
    if (t._last && now - t._last < 500) return;
    t._last = now;
    var zone = t.firstElementChild, x, y, n = 0;
    if (!zone) return;
    do { x = 14 + Math.random() * 72; y = 14 + Math.random() * 66; n++; } while (x < 36 && y < 20 && n < 8);
    var h = document.createElement('span');
    h.className = 'fz-hole'; h.setAttribute('aria-hidden', 'true');
    h.style.left = x.toFixed(1) + '%'; h.style.top = y.toFixed(1) + '%';
    zone.appendChild(h);
    var holes = zone.querySelectorAll('.fz-hole');
    if (holes.length > 4) holes[0].remove();
    if (auto) { t.classList.add('is-punched'); setTimeout(function () { t.classList.remove('is-punched'); }, 1100); }
  }
  document.addEventListener('pointerover', function (e) {
    if (e.pointerType !== 'mouse' && e.pointerType !== 'pen') return;
    var t = e.target.closest && e.target.closest('.fz-ticket');
    if (!t || t === lastTicket) return;
    lastTicket = t; punch(t, false);
  });
  document.addEventListener('pointerout', function (e) {
    var t = e.target.closest && e.target.closest('.fz-ticket');
    if (t && (!e.relatedTarget || !t.contains(e.relatedTarget))) { if (lastTicket === t) lastTicket = null; }
  });
  document.addEventListener('focusin', function (e) {
    var t = e.target.closest && e.target.closest('.fz-ticket');
    if (t && e.target.matches(':focus-visible')) punch(t, false);
  });
  var io = null;
  FZ.initTickets = function (root) {
    if (!('IntersectionObserver' in window) || !window.matchMedia('(hover: none)').matches) return;
    if (!io) io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { punch(en.target, true); io.unobserve(en.target); } });
    }, { threshold: 0.8 });
    FZ.qsa('.fz-ticket:not([data-punch-watch])', root).forEach(function (t) { t.setAttribute('data-punch-watch', ''); io.observe(t); });
  };

  /* ---------- Fin de piste : on remonte vite, mais en voyant défiler la page ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-fin-de-piste]');
    if (!a) return;
    e.preventDefault();
    var y0 = window.scrollY, root = document.documentElement;
    if (y0 < 4) return;
    if (FZ.reduceMotion()) { window.scrollTo(0, 0); return; }
    var dur = Math.min(1800, Math.max(700, y0 * 0.2)), t0 = null, prev = root.style.scrollBehavior;
    root.style.scrollBehavior = 'auto';
    function ease(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
    function step(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min(1, (ts - t0) / dur);
      window.scrollTo(0, Math.round(y0 * (1 - ease(p))));
      if (p < 1) { requestAnimationFrame(step); }
      else {
        root.style.scrollBehavior = prev;
        var hd = document.querySelector('header');
        if (hd) { hd.setAttribute('tabindex', '-1'); hd.focus({ preventScroll: true }); }
      }
    }
    requestAnimationFrame(step);
  });

  /* ---------- Copier dans le presse-papiers (boutons [data-fz-copy]) ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-fz-copy]');
    if (!b) return;
    var txt = b.getAttribute('data-fz-copy');
    var done = function () {
      var lab = b.querySelector('[data-fz-copy-label]'), old = lab ? lab.textContent : '';
      b.classList.add('is-copied');
      if (lab) lab.textContent = b.getAttribute('data-fz-copied') || 'Copié';
      setTimeout(function () { b.classList.remove('is-copied'); if (lab) lab.textContent = old; }, 1800);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(txt).then(done, done);
    else {
      var ta = document.createElement('textarea'); ta.value = txt; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select(); try { document.execCommand('copy'); } catch (err) {} ta.remove(); done();
    }
  });

  /* ---------- Démarrage et rechargement de sections ---------- */
  function boot() { FZ.initTickets(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { FZ.initTickets(e.target); });
})();
